/*httpHost的处理*/
//http:'http://djy.1942it.com:8087',//线上
//http:'http://192.168.3.222:8080',//本地
//http:'http://www.1942it.com:8084',////测试(zkePA2)
//http: 'http://zkep2.1942it.com:8080', //正式（最后）(zkePA)
//TODO
var httpHost = 'http://zkep2.1942it.com'  //------线上-------
//var httpHost = 'http://restest.380v.com'  //------测试2-------
//var httpHost = 'http://www.1942it.com'+'/zkepA'   //------测试------
//var httpHost = 'http://192.168.3.222'+'/zkepA'

export default {
	httpHost
}


//////////////////
// WEBPACK FOOTER
// ./static/js/httpHost.js
// module id = null
// module chunks = 